import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import { CommonConfig } from '../../configs/config.common';
import * as T_T from 'cryface';

@Component
export default class Page404 extends Vue {
   public title: string = 'Page404';

   public configs = new CommonConfig();

   public userInfo: any = null;

   public hideGoHome: any = false;

   @Prop({ default: 'Please go to the home page by clicking the button below.' })
   public content: any;

   public getLogo() {
      return this.configs.epicLogo;
   }

   public getFourOFourPic() {
      return this.configs.fourOFourImg;
   }

   public gohome() {
      this.$router.push('/');
   }

   public goContactUs() {
      window.open(`http://${this.configs.worldWide[0]}/contact-us`);
   }

   @Watch('$store.state.auth.userInfo', { immediate: true, deep: true })
   public async onUserChanged(val: any, oldVal: any) {
      if (T_T.simpleDetect(val.value)) {
         if (val.value.website_status === false) {
            this.hideGoHome = true;
            this.content = 'Agent website is inactive now.';
         }
      }
   }
}
